import React from 'react';
export function Hero() {
  const scrollToPricing = () => {
    const el = document.getElementById('pricing');
    if (el) {
      const top = el.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({
        top,
        behavior: 'smooth'
      });
    }
  };
  return <div className="pt-12 pb-8 px-4 max-w-4xl mx-auto text-center" data-id="element-182">
      <div className="inline-block bg-brand-card border border-brand-borderGlow/30 rounded-full px-4 py-1.5 font-semibold text-brand-subtitle mb-4 text-[12px] tracking-[0.15em] uppercase" data-id="element-183">
        💃 ATENCIÓN: INSTRUCTORES DE BACHATA
      </div>

      <h1 className="text-brand-title md:text-6xl font-bold tracking-tight mb-3 text-[32px] leading-tight" data-id="element-184">
        Deja de perder tiempo planificando tus clases.
      </h1>

      

      <div className="my-6 flex justify-center" data-id="element-185">
        <img src="https://cdn.magicpatterns.com/uploads/uBAEsi8AVseHCSgsFmEDdQ/mockup-bachata-v99.webp.webp" alt="El Manual del Instructor de Bachata — 6 Tomos + 3 Bonos" width="800" height="800" fetchPriority="high" loading="eager" decoding="sync" className="w-full max-w-2xl" data-id="element-186" />
      </div>

      <p className="text-lg md:text-xl text-brand-subtitle font-semibold mb-6 tracking-wide font-body" data-id="element-187">
        El sistema de planificación y metodología para leer y usar al instante.
        Lo utilizan los instructores de bachata que llenan salas en España.
      </p>

      <button onClick={scrollToPricing} className="bg-gradient-gold hover:opacity-90 text-brand-bg font-bold text-xl md:text-2xl py-4 px-8 rounded-2xl transition-opacity w-full md:w-auto mb-3 tracking-wide" data-id="element-188">
        🚀QUIERO PLANIFICAR EN 10 MINUTOS — 13,99€
      </button>

      <div className="text-brand-text font-medium text-sm tracking-wide mb-6" data-id="element-189">
        ⚡ Acceso inmediato · 🛡️ Garantía 7 días · 💳 Pago único
      </div>

      <div className="flex items-center justify-center gap-2 mb-4 text-sm" data-id="element-190">
        <div className="flex text-brand-gold" data-id="element-191">⭐⭐⭐⭐⭐</div>
        <span className="text-brand-text font-medium" data-id="element-192">4.9/5</span>
        <span className="text-brand-textMuted" data-id="element-193">·</span>
        <span className="text-brand-text font-medium" data-id="element-194">
          🔥 24 instructores lo compraron hoy
        </span>
      </div>

      <div className="text-brand-textMuted font-medium text-sm tracking-wide" data-id="element-195">
        🇪🇸 +300 instructores ya enseñan mejor en España
      </div>
    </div>;
}